import AccountRepository from '@/repository/account/AccountRepository';
import FaqRepository from '@/repository/faq/FaqRepository';
import ExamRepository from '@/repository/exam/ExamRepository';
import ExamineeRepository from '@/repository/examinee/ExamineeRepository';
import EntryRepository from '@/repository/entry/EntryRepository';
import RankRepository from '@/repository/exam/RankRepository';
import MyPageRepository from '@/repository/mypage/MyPageRepository';
import GuestRepository from '@/repository/guest/GuestRepository';
import GoodsRepository from '@/repository/goods/GoodsRepository';
import TemplateRepository from './template/TemplateRepository';

interface RepositoriesInterface {
  account: AccountRepository;
  faq: FaqRepository;
  exam: ExamRepository;
  examinee: ExamineeRepository;
  entry: EntryRepository;
  rank: RankRepository;
  mypage: MyPageRepository;
  guest: GuestRepository;
  goods: GoodsRepository;
  template: TemplateRepository;
}

const repositories = {
  account: new AccountRepository(),
  faq: new FaqRepository(),
  exam: new ExamRepository(),
  examinee: new ExamineeRepository(),
  entry: new EntryRepository(),
  rank: new RankRepository(),
  mypage: new MyPageRepository(),
  guest: new GuestRepository(),
  goods: new GoodsRepository(),
  template: new TemplateRepository(),
} as RepositoriesInterface;

/**
 * リポジトリファクトリ
 */
const RepositoryFactory = {
  /**
   *  リポジトリインスタンスオブジェクトを返す
   */
  get: (): RepositoriesInterface => repositories,
};
export default RepositoryFactory;
